define(['underscore',
        'text!./templates/basler-confirmations-directive.html'],
    (_, templateStr) => {

        return function () {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    questionSets: '=baslerConfirmations',
                },
                link: function ($scope, element) {
                },
            };
        };
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerConfirmationsDirective.js